<template>
  <!-- 共享供应商组下拉嵌套选择 -->
  <tree-select
    v-model="treeCopyIds"
    style="display: inline-block"
    class="tree-select"
    :placeholder="placeholder"
    :options="categoryTreeList"
    :normalizer="normalizer"
    :value-format="valueFormat"
    append-to-body
    no-options-text="暂无数据"
    no-results-text="暂无数据"
    clear-value-text="清空选项"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
// 组件
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// 字典
import { shareLibraryTypeDict } from '@/dictionary/supplier-management/supplier-lib'

// api接口
import { getSupplierSharedCategoriesApi } from '@/api/supplier-management/supplier-lib'

// 工具
import { listTransformTree } from '@/utils/utils'

export default {
  name: 'ShareCategoriesSelect',

  components: {
    TreeSelect
  },

  model: {
    prop: 'treeIds',
    event: 'change'
  },

  props: {
    treeIds: {
      type: [String, Number, Array, Object],
      default: ''
    },
    valueFormat: {
      type: String,
      default: 'object'
    },
    placeholder: {
      type: String,
      default: '请选择分组'
    },
    /**
     * 初始加载组件是否需要获取数据
     */
    needInit: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      categoryTreeList: [],
    }
  },

  computed: {
    treeCopyIds: {
      get() {
        return this.treeIds || this.treeIds === 0 ? this.treeIds : null
      },
      set(val) {
        this.$emit('change', val)
      }
    },

  },

  created() {
    this.needInit && this.initData()
  },

  methods: {
    initData() {
      this.getCategoriesTreeData()
    },

    getCategoriesTreeData() {
      getSupplierSharedCategoriesApi()
        .then(res => {
          const data = res.data || []

          const tempArray = []
          data.forEach(item => {
            const { sharedInfoList, ...other } = item

            const list = listTransformTree((sharedInfoList || []).map(x => ({ ...x, libraryType: shareLibraryTypeDict.GROUP.value })), 'categoryId')
            tempArray.push({
              ...other,
              libraryType: shareLibraryTypeDict.COMPANY.value,
              categoryId: `company-${other.sharedCompanyId}`,
              categoryName: other.sharedCompanyName,
              supplierCount: other.sharedSupplierCount,
              children: list
            })
          })

          this.categoryTreeList = tempArray
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    // 数据转换
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.categoryId,
        label: node.categoryName,
        children: node.children
      }
    }
  }
}
</script>
